import ZYcurtain from '../ZYcurtain/ZYcurtain';
import styles from './mode.module.css';

const Mode = ({ m2sText }) => {
  const modeContent = [
    {
      text: {
        h: m2sText['text22'],
        p: m2sText['text23'],
      },
      src: 'https://bucket.zhiyun-tech.com/detail/m2s/m2s-mode-video-1.mp4',
    },
    {
      text: m2sText['text32'],
      src: 'https://bucket.zhiyun-tech.com/detail/m2s/m2s-mode-video-2.mp4',
    },
    {
      text: m2sText['text33'],
      src: 'https://bucket.zhiyun-tech.com/detail/m2s/m2s-mode-video-3.mp4',
    },
    // {
    //   text: 'GO',
    //   background: 'https://picsum.photos/1920/1080?random=3',
    // },
  ];
  return (
    <ZYcurtain
      className={styles.modeCtn}
      content={modeContent}
      textAlign="center"
      end="+=1400"
      media='video'
    />
  );
};

export default Mode;
